//@ts-nocheck
import React from "react";
import { RaiseColors, Icon, Typography } from "components/mui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var errorText = {
  display: "flex",
  flexDirection: "column",
  textAlign: "center"
};
var exclamationIcon = {
  fontSize: "36px",
  paddingBottom: "18px"
};
var containerStyle = {
  width: "403px",
  position: "absolute",
  left: "638px",
  top: "292px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};
var ErrorFallbackComponent = function ErrorFallbackComponent() {
  return /*#__PURE__*/_jsxs("div", {
    style: containerStyle,
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Icon, {
        className: "fas fa-exclamation-triangle",
        color: RaiseColors.peach,
        style: exclamationIcon
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        paddingBottom: "14px"
      },
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        weight: "semibold",
        color: RaiseColors.destructive500,
        children: "Oops! Looks like we're having trouble."
      })
    }), /*#__PURE__*/_jsxs("div", {
      style: errorText,
      children: [/*#__PURE__*/_jsx(Typography, {
        color: RaiseColors.gray300,
        children: "Please try refreshing the page. If the issue persists,"
      }), /*#__PURE__*/_jsxs(Typography, {
        color: RaiseColors.gray300,
        children: [" ", "please create a ticket through Marker.io", " "]
      })]
    })]
  });
};
export default ErrorFallbackComponent;